import { render } from "./QuanLyThoiVu.vue?vue&type=template&id=3cbec5da&scoped=true"
import script from "./QuanLyThoiVu.vue?vue&type=script&lang=js"
export * from "./QuanLyThoiVu.vue?vue&type=script&lang=js"

import "./QuanLyThoiVu.vue?vue&type=style&index=0&id=3cbec5da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbec5da"]])

export default __exports__